import { useEffect, lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Nav } from "./components/Nav";
import { Footer } from "./components/Footer";
import Home from "./pages/Home";
import Experiences from "./pages/Experiences";
import WhoWeServe from "./pages/WhoWeServe";
import About from "./pages/About";
import Sponsorships from "./pages/Sponsorships";
import Contact from "./pages/Contact";
const Admin = lazy(() => import("./pages/Admin"));
import Privacy from "./pages/Privacy";
import NotFound from "./pages/NotFound";
import { useAnalytics } from "./analytics/useAnalytics";
import { PlanEventProvider } from "./components/PlanEventModal";

const Analytics = () => { useAnalytics(); return null; };

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) {
        const go = () => el.scrollIntoView({ behavior: "smooth", block: "start" });
        requestAnimationFrame(go);
        const t = [setTimeout(go, 350), setTimeout(go, 900)];
        return () => t.forEach(clearTimeout);
      }
    }
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, hash]);
  return null;
};

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Analytics />
      <PlanEventProvider>
      <div className="flex min-h-screen flex-col bg-white text-black">
        <Nav />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/experiences" element={<Experiences />} />
            <Route path="/who-we-serve" element={<WhoWeServe />} />
            <Route path="/about" element={<About />} />
            <Route path="/sponsorships" element={<Sponsorships />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/admin/*" element={<Suspense fallback={<section className="min-h-[60vh] bg-white" />}><Admin /></Suspense>} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
      </div>
      </PlanEventProvider>
    </BrowserRouter>
  );
}

export default App;
